import { Component, OnInit } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { JSONSchema7 } from 'json-schema';
import { MainService } from '../services/main.service';
import Swal from 'sweetalert2';
import { MainService as crudMain } from 'svm-crudui';

@Component({
  selector: 'app-classification',
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.css']
})
export class ClassificationComponent implements OnInit {

  constructor(public main: MainService, private formlyJsonschema: FormlyJsonschema, public crudMain: crudMain) { }
  CL: any = {}
  listflag = true
  viewflag = false;
  addflag = false;
  updateflag = false;


  async ngOnInit() {
    // await this.getSchema({ "title": "Constant Value", "type": "object", "properties": { "cntry_name": { "type": "string" }, "cntry_phone_cd": { "type": "string", "min_len": 1, "maxLength": 2 } }, "required": ["cntry_name", "cntry_phone_cd"], "additional_items": false })
    await this.getAllTerms()
    await this.getDefaultcodevalues()

  }
  async onViewClicked(item: any) {
    console.log(item);
    await this.setDataOnUpdateorView(item)
    this.setflag(true, false, false, false)



  }
  async onUpdateClicked(item: any) {
    console.log(item);
    await this.setDataOnUpdateorView(item)
    this.setflag(false, true, false, false)
  }
  clItem = {}
  async setDataOnUpdateorView(item: any) {
    this.clItem = item
    this.clarr = []
    if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'SV') {
      let clobj = {}
      clobj['cl_cd'] = item['cl_cd']
      clobj['cl_val'] = item['cl_val']
      this.clarr.push(clobj)
    }
    else if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'MV') {
      this.classificationCode = item['cl_cd']
      await this.getSchema(this.selectedTermId?.di_tcd_json?.cl_type?.['mv_schema'])
      this.model = item['cl_tcd_json']?.['mv_val']
    }
  }

  async onAddButtonClick() {
    await this.getform()
    this.reset()
    await this.setflag(false, false, true, false)
  }
  async getform() {
    if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'MV') {
      this.getSchema(this.selectedTermId?.di_tcd_json?.cl_type?.['mv_schema'])
    }

  }
  async setflag(v, u, a, l) {
    this.viewflag = v;
    this.addflag = a;
    this.updateflag = u;
    this.listflag = l


  }
  termarr = []
  selectedTermId: any = {}
  async getAllTerms() {
    this.termarr = []
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "TR"
          }
        },

        {
          "di_tcd_json.cl_type": {
            "!=": ""
          }
        },

      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,


    };
    try {

      const resp = await this.main.getListData(req_obj);
      if (!resp.error) {
        this.termarr = resp['data']
        this.selectedTermId = this.termarr[0]
      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }
  }
  async getDefaultcodevalues() {
    if (this.selectedTermId) {
      await this.inputchange()
    }
  }
  async inputchange() {
    this.CL = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      code: 'PF',
      value: 'Classification',

      cards: {
        mainHeading: 'cl_cd',
        subHeading: 'cl_val',
        imagePath: '../../assets/cl.png',
        actionAreaLeft: 'status_cd',
        actionAreaMid: 'captured_at'

      },
      crudconfig: {
        viewEvent: true,
        updateEvent: true
      }

    }
    let dummyinputobj = JSON.parse(JSON.stringify(this.CL))
    dummyinputobj.filters = {
      "and": [
        { "di_id": { "=": this.selectedTermId?.['di_id'] } },
        {
          "cl_tcd": {
            "!=": "HIER"
          }
        }
      ]
    }
    this.CL = dummyinputobj

  }
  clarr = []
  async onAddClassification() {
    this.clarr.push({})
  }
  async onDeleteClassification(index) {
    this.clarr.splice(index, 1)
  }
  async insertClassifications(di_id: any, clarr: any) {
    let classificationReqObj = {
      'pf_path': 'dd',
      'pf_name': 'cl',
      'app_cd': 'DD',
      columns: ["di_id", "cl_cd", "cl_val", "cl_tcd", "cl_tcd_json"],
      values: []
    };

    for (let i = 0; i < clarr.length; i++) {
      const classification = clarr[i];

      classificationReqObj.values.push([
        di_id,
        classification.cl_cd,
        classification.cl_val,
        classification?.cl_tcd || 'AV',
        classification?.cl_tcd_json || { "av_tcd": "SV" }
      ]);
    }

    try {
      let resp = await this.main.addMultiData(classificationReqObj);
      if (!resp['error']) {
        await this.inputchange()
        await this.reset()
        await this.setflag(false, false, false, true)

        Swal.fire('Success!', 'Classifications inserted successfully.', 'success');

      } else {
        Swal.fire('Error!', 'Failed to insert classifications.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to insert classifications.', 'error');
    }
  }
  async reset() {
    this.clarr = []
    this.classificationCode = null

  }
  async submit() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to Add the Classification`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, add it!'
    });


    if (result.isConfirmed) {
      if (await this.validateForm()) {
        if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'MV') {
          await this.formatData()
        }
        else {
          await this.insertClassifications(this.selectedTermId?.['di_id'], this.clarr)

        }


      }
    }
  }
  classificationCode: any
  async formatData() {
    console.log(this.model);
    let cl_obj = {}
    cl_obj['cl_cd'] = this.classificationCode
    cl_obj['cl_val'] = null
    cl_obj['cl_tcd'] = 'AV'
    cl_obj['cl_tcd_json'] =
      { "av_tcd": "MV", "mv_val": this.model }
    this.clarr = []
    this.clarr.push(cl_obj)
    await this.insertClassifications(this.selectedTermId?.['di_id'], this.clarr)




  }
  async validateForm(): Promise<boolean> {
   if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] === 'SV') {
     for (let classification of this.clarr) {
        if (!classification.cl_cd || !classification.cl_val) {
          await Swal.fire({
            icon: 'error',
            title: 'Missing Fields',
            text: 'Please fill in both Classification Code and Classification Value for all rows.',
          });
          return false; 
        }
      }
    } 
    
    else if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] === 'MV') {
    
      if (!this.classificationCode) {
        await Swal.fire({
          icon: 'error',
          title: 'Missing Classification Code',
          text: 'Classification Code is required for MV type.',
        });
        return false; 
      }
  
      if (this.form.invalid) {
        this.form.markAllAsTouched(); 
        await Swal.fire({
          icon: 'error',
          title: 'Invalid Fields',
          text: 'Please fill in all required fields for MV type.',
        });
        return false; 
      }
  
    
    } 
    else {
      await Swal.fire({
        icon: 'error',
        title: 'Unknown Type',
        text: 'Unknown classification type.',
      });
      return false; 
    }
    //  await Swal.fire({
    //   icon: 'success',
    //   title: 'Validation Passed',
    //   text: 'All fields are valid.',
    // });
    return true;
  }
  
  form = new FormGroup({});
  fields: FormlyFieldConfig[]
  //  form = new FormGroup({});
  formData: any = {}
  model = {};

  async getSchema(schema: any) {
    console.log(schema);

    await this.crudMain.addTitlesToSchema(schema)
    console.log(schema);

    this.fields = [this.formlyJsonschema.toFieldConfig(schema, {
      map: (field: FormlyFieldConfig, schema: JSONSchema7) => {
        //  this.model = this.formData;
        //   this.originalModel = JSON.parse(JSON.stringify(this.model));

        // if (this.rrvconfig.mode === 'view') {
        //   field.templateOptions.disabled = true;
        // }

        if (schema.format === 'date-time') {
          field.templateOptions.type = 'datetime-local';
        } else if (schema.format === 'date') {
          field.templateOptions.type = 'date';
        } else if (schema.format === 'time') {
          field.templateOptions.type = 'time';
        } else if (schema.format === 'email') {
          field.templateOptions.type = 'email';
        }
        field.templateOptions.label = schema.title;
        // }
        if (typeof field.key === 'string' && field.key.includes('json')) {
          if (!this.model[field.key]) {
            this.model[field.key] = JSON.stringify({});
          }
        }

        return field;
      }
    })];
    console.log(this.fields, this.model);


  }
  gotolist() {
    this.setflag(false, false, false, true)
  }
  async update() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to Update the Classification`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Update it!'
    });


    if (result.isConfirmed) {
      if (await this.validateForm()) {
        await this.formatupdateobj()



      }
    }

  }
  async formatupdateobj() {
    let cl = {}
    if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'SV') {
      cl['cl_cd'] = this.clarr[0]['cl_cd']
      cl['cl_val'] = this.clarr[0]['cl_val']
      cl['cl_tcd'] = this.clItem['cl_tcd']
      cl['cl_tcd_json'] = this.clItem['cl_tcd_json']
      cl['cl_id'] = this.clItem['cl_id']
      await this.updatecl(cl)


    }
    else if (this.selectedTermId?.di_tcd_json?.cl_type?.['av_tcd'] == 'MV') {
      cl['cl_cd'] = this.classificationCode
      cl['cl_val'] = this.clItem['cl_val']
      cl['cl_tcd'] = this.clItem['cl_tcd']
      cl['cl_tcd_json'] =
        { "av_tcd": "MV", "mv_val": this.model }
      cl['cl_id'] = this.clItem['cl_id']
      await this.updatecl(cl)


    }



  }
  async updatecl(cl: any) {

    let updateobj = {}
    updateobj['cl_cd'] = cl['cl_cd']
    updateobj['cl_val'] = cl['cl_val']
    updateobj['cl_tcd'] = cl['cl_tcd']
    updateobj['cl_tcd_json'] = cl['cl_tcd_json']

    let where: any = {}

    where['cl_id'] = cl['cl_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'cl', app_cd: 'DD', set: updateobj, where: where }).then(async response => {
      if (!response['error']) {
        Swal.fire('Success!', 'Classifications updated successfully.', 'success');
        await this.inputchange()
        await this.reset()
        await this.setflag(false, false, false, true)
      } else {
        Swal.fire('Error!', 'Failed to update  classifications.', 'error');
      }
    }).catch(error => {
      Swal.fire('Error!', 'Failed to update  classifications.', 'error');

    });


  }


}
